import * as React from "react";
import { useTealiumEventProperties, useTrackPageView } from "@grandvisionhq/svc-tealium/events";
const usePageViewAccountWishlistEvent = (wishlistData, wishlistLoading) => {
  const { commonEventProperties, getCommonUserProperties } = useTealiumEventProperties();
  const accountWishlistPageView = React.useCallback(
    () => new Promise(async (resolve) => {
      if (wishlistLoading) return;
      const commonUserProperties = await getCommonUserProperties();
      if (!commonUserProperties) return;
      resolve({
        ...commonEventProperties,
        ...commonUserProperties,
        id: "VirtualPage-View",
        Page_Type: "Wishlist",
        Page_Section1: "Account",
        Page_Design: wishlistData?.items.length ? void 0 : "Empty"
      });
    }),
    [getCommonUserProperties, wishlistLoading, commonEventProperties, wishlistData?.items.length]
  );
  useTrackPageView(accountWishlistPageView);
};
export {
  usePageViewAccountWishlistEvent
};
//# sourceMappingURL=use-pageview-account-wishlist-event.js.map
